import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=37985169"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports